export default "__VITE_ASSET__JopJo6yb__"